<template>
    <!-- The scrubber: drag to a time; it seeks when let go, so the audio doesn't stutter. -->
    <div class="ab-seek-wrap" :class="{ 'is-big': big }">
        <span class="ab-seek-time">{{ clock(shown) }}</span>
        <input
            type="range"
            class="ab-seek"
            min="0"
            :max="duration"
            step="1"
            :value="shown"
            :disabled="!player.current"
            :style="{ '--fill': `${duration ? (shown / duration) * 100 : 0}%` }"
            :aria-label="`Seek, ${clock(shown)} of ${clock(duration)}`"
            @input="drag = Number($event.target.value)"
            @change="commit"
        />
        <span class="ab-seek-time text-right">-{{ clock(duration - shown) }}</span>
    </div>
</template>

<script>
import { player, seek, clock } from '../../helpers/audiobook'

export default {
    name: 'SeekBar',
    props: {
        big: { type: Boolean, default: false },
    },
    data() {
        return { player, drag: null }
    },
    computed: {
        duration() { return player.duration || 0 },
        shown() { return this.drag ?? player.position },
    },
    methods: {
        clock,
        commit() {
            if (this.drag != null) seek(this.drag)
            this.drag = null
        },
    },
}
</script>

<style>
.ab-seek-wrap { display: flex; width: 100%; align-items: center; gap: 0.75rem; --track: 4px; --thumb: 12px; }
.ab-seek-wrap.is-big { --track: 6px; --thumb: 16px; }
.ab-seek-time { width: 3.25rem; flex-shrink: 0; font-size: 0.68rem; font-variant-numeric: tabular-nums; color: var(--ab-muted); }
.is-big .ab-seek-time { font-size: 0.75rem; }
/* A 24px-tall input (an easy touch target) around a thin painted track. */
.ab-seek { height: 1.5rem; width: 100%; cursor: pointer; appearance: none; -webkit-appearance: none; background: transparent; }
.ab-seek::-webkit-slider-runnable-track { height: var(--track); border-radius: 9999px; background: linear-gradient(to right, var(--ab-gold) var(--fill), var(--ab-line-strong) var(--fill)); }
.ab-seek::-moz-range-track { height: var(--track); border-radius: 9999px; background: var(--ab-line-strong); }
.ab-seek::-moz-range-progress { height: var(--track); border-radius: 9999px; background: var(--ab-gold); }
.ab-seek::-webkit-slider-thumb {
    -webkit-appearance: none; appearance: none; border-radius: 9999px; background: var(--ab-accent); box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    width: var(--thumb); height: var(--thumb); margin-top: calc((var(--track) - var(--thumb)) / 2); opacity: 0; transition: opacity 0.15s;
}
.ab-seek::-moz-range-thumb { border: 0; border-radius: 9999px; background: var(--ab-accent); width: var(--thumb); height: var(--thumb); }
/* one browser's pseudo-element per rule: an unknown one voids the whole selector list */
.ab-seek-wrap:hover .ab-seek::-webkit-slider-thumb { opacity: 1; }
.ab-seek:focus-visible::-webkit-slider-thumb { opacity: 1; }
.is-big .ab-seek::-webkit-slider-thumb { opacity: 1; }
@media (hover: none) { .ab-seek::-webkit-slider-thumb { opacity: 1; } }
.ab-seek:disabled { cursor: default; opacity: 0.5; }
</style>
